import React from "react";
import CustomMap from "./components/CustomMap";
import MapForm from "./components/MapForm";
import Confirmation from "./components/modals/confirmation";
import NavBar from "./components/NavBar";
import axios from 'axios'
import Tabs from "./components/tabs";
import FullScreenTable from "./components/modals/fullscreenTable";
import AddToMap from "./components/modals/addToMap";
import ErrorModal from "./components/modals/ErrorModal";

// make to call to get user from redux or atom


export default class App extends React.Component {

  constructor(props) {
    super(props);
    // window.addEventListener('click', (e) => {
    //   if (!document.getElementById('TabTable').contains(e.target)) {
    //     this.setState({
    //       showTable: false
    //     });
    //     this.showTheTable()
    //   }
    // });
    this.state = {
      markers: [],
      showForm: false,
      addedLatLng: [],
      cancelMarker: false,
      markerData: {},
      showConfirmation: false,
      showTable: false,
      service: 'Hydrants',
      serviceData: ['fdsafasd'],
      fullScreen: false,
      movingMarker: false,
      resetMarker: false,
      closeAllPopups: false,
      showFormAndAddMarker: false
    };
    this.onSettingsChanged = this.onSettingsChanged.bind(this);
  }

  componentDidMount = async () => {
    // window.location = ("" + window.location).replace("#", "@");
    await axios.get('/api/hydrants')
      .then(({ data }) => {
        if (data && data.message === "No token provided") {
          window.location = '/login'
        } else {
          console.log('problem here', data)
          this.setState({
            markers: data.result[0],
            serviceData: data.result[0]
          })
        }
      })
      .catch((err) => {
        console.log(err)
        
      })

  }

  refreshData = async () => {
    await axios.get('/api/hydrants')
      .then(({ data }) => {
        this.setState({
          markers: data.result[0],
          showForm: false,
          markerData: {},
          cancelMarker: false,
          serviceData: data.result[0],
          addedLatLng: []
        })
      })
    document.getElementsByClassName('leaflet-grab')[0].style.cursor = 'grab'
  }

  refreshDataWithOutClosing = async () => {
    await axios.get('/api/hydrants')
      .then(({ data }) => {
        this.setState({
          markers: data.result[0],
          markerData: data.result[0].filter(x => x.HydrantID === this.state.markerData.HydrantID)[0],
          cancelMarker: false,
          serviceData: data.result[0],
        })
      })
    document.getElementsByClassName('leaflet-grab')[0].style.cursor = 'grab'
  }

  setData = async () => {
    const { data } = await axios.get('/api/hydrants')
    this.setState({ serviceData: data.result[0] })
    return data.result[0]
  }

  onSettingsChanged(data) {
    this.setState({ data: data.val() });
  }

  shoeTheForm = () => {
    //clear marker 
    this.setState({
      markerData: this.state.showForm ? null : this.state.markerData,
      showForm: !this.state.showForm,
      cancelMarker: !this.state.cancelMarker,
      closeAllPopups: !this.state.closeAllPopups
    })
    // var elements = document.getElementsByClassName('leaflet-container')
    // var element2 = document.getElementsByClassName('map-form')
    // var element3 = document.getElementsByClassName('mapInput')
    // if (this.state.showForm) {
    //   element2[0].style.transition = 'width 2s, visibility 0s 2s, left 2s 1s';
    //   element2[0].style.left = '3%';
    //   element3[0].style.transition = 'visibility 600ms';
    //   elements[0].style.width = '100%'
    //   element2[0].style.visibility = 'hidden'
    //   element3[0].style.visibility = 'hidden';
    //   element2[0].style.width = '0%'
    // } else {
    //   element2[0].style.transition = 'width 2s, visibility 2s, left 500ms';
    //   element2[0].style.left = '0%';
    //   element3[0].style.transition = 'visibility 300ms 500ms';
    //   elements[0].style.width = '75%';
    //   element2[0].style.visibility = 'visible';
    //   element3[0].style.visibility = 'visible';
    //   element2[0].style.width = '25%'
    // }

  }

  EditMarker = (key) => {
    // var elements = document.getElementsByClassName('leaflet-container')
    // var element2 = document.getElementsByClassName('map-form')
    // var element3 = document.getElementsByClassName('mapInput')
    // element2[0].style.transition = 'width 2s, visibility 2s, left 500ms';
    // element2[0].style.left = '0%';
    // element3[0].style.transition = 'visibility 300ms 500ms';
    // elements[0].style.width = '75%';
    // element2[0].style.visibility = 'visible';
    // element3[0].style.visibility = 'visible';
    // element2[0].style.width = '25%'
    this.setState({
      showForm: true,
      cancelMarker: false,
      markerData: key.markerData,
      markerFormsProps: key
    })
  }

  addMarkerToMap = () => {
    if (!this.state.showFormAndAddMarker) {
      document.getElementsByClassName('leaflet-grab')[0].style.cursor = 'crosshair'
    } else {
      document.getElementsByClassName('leaflet-grab')[0].style.cursor = 'grab'
    }
    this.setState({
      showFormAndAddMarker: !this.state.showFormAndAddMarker
    })
  }

  showTheTable = (key) => {
    this.setState({
      showTable: !this.state.showTable
    })
    var elements = document.getElementsByClassName('leaflet-container')
    var element2 = document.getElementsByClassName('tabsClass')
    var element3 = document.getElementsByClassName('tabContent')
    var element4 = document.getElementsByClassName('activeTab')
    var element5 = document.getElementsByClassName('activeTabDiv')

    if (!this.state.showTable) {
      // elements[0].style.transition = 'height 2s';
      // elements[0].style.height = '37vh'

      // element2[0].style.transition = 'height 2s';
      // element2[0].style.bottom = '0vh'
      element2[0].style.height = '61%'
      element2[0].style.overflow = 'unset'

      // element3[0].style.transition = 'visibility 2s 2s';
      element3[0].style.visibility = 'visible';

      element4[0].style.backgroundColor = '#fff';
      element4[0].style.color = '#212529';

      element5[0].style.color = 'black';
    } else {
      // elements[0].style.height = '92%';

      // element2[0].style.transition = 'height 2s';
      element2[0].style.bottom = '0px'
      element2[0].style.height = '43px';
      element2[0].style.overflow = 'hidden'

      element3[0].style.visibility = 'hidden';

      element4[0].style.backgroundColor = '#212529';
      element4[0].style.color = '#fff ';

      element5[0].style.color = '#fff';
    }
  }

  moveMarker = (key, refresh) => {

    if (this.state.movingMarker && !refresh) {
      this.setState({
        resetMarker: true,
        markerData: key,
        movingMarker: !this.state.movingMarker,
      })
    } else {
      this.setState({
        markerData: key,
        movingMarker: !this.state.movingMarker,
        resetMarker: false
      })
    }
  }

  deleteMarker = (deleteMarker) => {
    if (this.state.showConfirmation) {
      this.setState({
        showConfirmation: false,
      })
    } else {
      this.setState({
        showConfirmation: true,
        deleteMarkerID: deleteMarker
      })
    }
  }

  CallBackToParent = (latLng) => {
    console.log('gettingHere')
    this.setState({ addedLatLng: latLng })
  }

  confirm = async () => {
    await axios.post('/api/hydrantDEL', { asset: this.state.deleteMarkerID })
      .then(response => {
        window.location.reload()
      })
      .catch(error => console.log('error', error))
  }

  ShowFullscreen = () => {
    this.setState({ fullScreen: !this.state.fullScreen })
  }

  onShowError = (error) => {
    this.setState({
      ErrorText: error
    })
  }

  onCancelError = () => {
    this.setState({
      ErrorText: null
    })
  }

  closeForm = () => {
    document.getElementsByClassName('leaflet-grab')[0].style.cursor = 'grab'
    this.setState({
      markerData: {},
      showForm: false,
      cancelMarker: true,
      closeAllPopups: false,
      showFormAndAddMarker: false
    })
  }

  render() {
    return (
      <div style={{ overflowX: 'hidden' }}>
        {this.state.showConfirmation ?
          <Confirmation
            text="Are you sure you want to delete this?"
            confirm={this.confirm}
            deleteMarker={this.deleteMarker.bind(this)}
          />
          : null}

        {this.state.fullScreen ?
          <FullScreenTable
            dataTable={() => this.setData()}
            ShowFullscreen={this.ShowFullscreen}
          />
          : null}

        {this.state.showForm ?
          <AddToMap
            data={this.state.markerData}
            serviceData={this.state.serviceData}
            markerFormsProps={this.state.markerFormsProps}
            user={{ Created_User: 'Brad Ciechanowski', ClientID: 1 }}
            addedLatLng={this.state.addedLatLng}
            addMarkerToMap={this.addMarkerToMap}
            cancel={this.closeForm}
            onShowError={this.onShowError}
            refreshData={this.refreshData}
            refreshDataWithOutClosing={this.refreshDataWithOutClosing}
          />
          : null}

        {this.state.ErrorText ?
          <ErrorModal
            text={this.state.ErrorText}
            onCancelError={this.onCancelError}
          />
          : null}

        <NavBar showForm={this.shoeTheForm} />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <CustomMap
              markers={this.state.markers}
              addingMarker={this.state.showForm}
              showFormAndAddMarker={this.state.showFormAndAddMarker}
              movingMarker={this.state.movingMarker}
              editingData={this.state.markerData}
              CallBackToParent={this.CallBackToParent.bind(this)}
              cancelMarker={this.state.cancelMarker}
              EditMarker={this.EditMarker.bind(this)}
              moveMarker={this.moveMarker.bind(this)}
              resetMarker={this.state.resetMarker}
              markerLatLng={this.state.addedLatLng}
              deleteMarker={this.deleteMarker.bind(this)}
              closeAllPopups={this.state.closeAllPopups}
            />
          </div>
          {/* <MapForm data={this.state.markerData} addedLatLng={this.state.addedLatLng} cancel={this.shoeTheForm} /> */}
        </div>

        {/* <Tabs showTable={this.showTheTable} showingTable={this.state.showTable} setData={() => this.setData()} ShowFullscreen={this.ShowFullscreen} /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js